import { TOUR_IDS, tourDefinitions } from './tourDefinitions';
import { getUrlTourStepFilter } from './productTourStorage';

export function resolveTourId(ctx) {
  if (ctx.isDemoProjectBootstrap && !ctx.isMobile) return TOUR_IDS.DEMO_BOOTSTRAP;
  if (ctx.isMobile) return TOUR_IDS.SHELL_MOBILE;
  return TOUR_IDS.SHELL_DESKTOP;
}

export function resolveActiveSteps(tourId, ctx) {
  const definition = tourDefinitions[tourId];
  if (!definition) return [];

  const urlFilter = getUrlTourStepFilter();

  return definition.steps.filter((step) => {
    if (step.enabled === false) return false;
    if (typeof step.when === 'function' && !step.when(ctx)) return false;
    if (urlFilter && !urlFilter.includes(step.id)) return false;
    if (step.skipIfMissing && typeof document !== 'undefined') {
      return Boolean(document.querySelector(step.target));
    }
    return true;
  });
}

export function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export const TOUR_OPEN_MOBILE_MENU_EVENT = 'archon-tour-open-mobile-menu';

export async function runStepBeforeShow(step, ctx, actions) {
  if (typeof step.beforeShow === 'function') {
    await step.beforeShow(ctx, actions);
    return;
  }

  switch (step.id) {
    case 'nav-menu':
    case 'project-selector':
    case 'user-profile':
      if (ctx.sidebarHidden) actions.revealSidebar();
      if (ctx.collapsed) actions.expandSidebar();
      await delay(350);
      break;
    case 'sidebar-controls':
      // Only reveal if fully hidden — never collapse an expanded sidebar just to
      // spotlight its controls, since the controls row is visible in every state.
      if (ctx.sidebarHidden) actions.revealSidebar();
      await delay(350);
      break;
    case 'mobile-metro':
      if (!ctx.isOnAppHome && typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(TOUR_OPEN_MOBILE_MENU_EVENT));
        await delay(350);
      }
      break;
    default:
      break;
  }
}
